import { BaseApi } from './BaseApi'
import {
    FiltroConsultarMetaBonus,
    PeriodoMetaBonus,
    RespostaConsultarMetaBonus,
} from '../../types/MetaBonus'

export class MetasBonusApi extends BaseApi {

    async ListarPeriodos(): Promise<PeriodoMetaBonus[]> {
        const resposta = await this.api.get(`/MetaBonus/ListarPeriodos`)
        return resposta.data
    }

    async Consultar(filtro: FiltroConsultarMetaBonus): Promise<RespostaConsultarMetaBonus> {
        const resposta = await this.api.post(`/MetaBonus/Consultar`, filtro)
        return resposta.data
    }
}